import { createStore } from 'vuex'
//modules
import cart from "./modules/cart";
export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    cart
  }
})
